import { Body, FileUpload, FlexBox, FormControl, FormError, Headline, InputMask } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';
import SignUpFormActions from 'partials/sign_up/FormActions';
import { getFileName, parseUrl } from 'partials/sign_up/helpers';
import { useForm } from 'react-hook-form';
import { AUCTION_ACCESS_FRANCHISE_DEALER_TYPE } from '../useAuctionAccessSignup';

const AuctionAccessDocuments = ({
	dealershipType,
	error,
	initialValues = {},
	isBackDisabled = false,
	onBack,
	onComplete,
}) => {
	const { t } = useTranslation(['common', 'signup']);
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
		setValue,
		watch,
	} = useForm({
		defaultValues: initialValues,
	});
	const driverLicenseFile = watch('driverLicenseFile');
	const driverLicenseUrl = watch('driverLicenseUrl');
	const isFranchiseDealer = dealershipType === AUCTION_ACCESS_FRANCHISE_DEALER_TYPE;

	const handleRemove = () => {
		setValue('driverLicenseUrl', null);
		setValue('driverLicenseFile', null, { shouldValidate: true });
	};

	return (
		<FlexBox flexDirection="column" gap="lg" width="100%">
			<FlexBox flexDirection="column" gap="sm">
				<Headline size="H2">{t('signup:auctionAccessLookup.documents.title')}</Headline>
				<Body>{t('signup:auctionAccessLookup.documents.subTitle')}</Body>
			</FlexBox>
			<FormControl label={t('signup:steps.step3.taxID')} formErrors={errors}>
				<InputMask
					id="auction-access-tax-id"
					inputMode="numeric"
					mask="99-9999-9999"
					placeholder={t('signup:steps.step3.taxIDPlaceholder')}
					defaultValue={initialValues.taxID}
					{...register('taxID')}
				/>
			</FormControl>
			{!isFranchiseDealer && (
				// in case that dealership type could not be loaded from partial signup we do not make it required to avoid blocking users at that step.
				<FormControl
					label={t('signup:steps.step3.driverLicenseFile')}
					formErrors={errors}
					required={Boolean(dealershipType)}
				>
					<FileUpload
						accept={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
						lastFileName={getFileName(driverLicenseFile)}
						lastFileUrl={driverLicenseUrl || parseUrl(driverLicenseFile)}
						handleRemove={handleRemove}
						fullWidth
						{...register('driverLicenseFile', {
							validate: (files) => files?.length > 0 || t('signup:steps.step3.driverLicenseRequired'),
						})}
					/>
				</FormControl>
			)}
			<FormError text={error} />
			<SignUpFormActions
				backCopy={t('signup:actions.back')}
				handleSubmit={handleSubmit(onComplete)}
				isBackDisabled={isBackDisabled}
				isSubmitting={isSubmitting}
				nextCopy={t('signup:actions.next')}
				onBack={onBack}
			/>
		</FlexBox>
	);
};

export default AuctionAccessDocuments;
